<div class="map-form-container flex flex-row justify-content-between flex-wrap">
  <div class="map-section  col-6 flex flex-column gap-2">
    @if (topCandidates.length > 0) {
      <div class="candidate-toolbar flex flex-column gap-2">
        @if (topCandidates.length > 1) {
          <div class="flex flex-wrap gap-2 align-items-center">
            <span class="text-sm">{{ 'CROP_IA_PREVIEW_CANDIDATE' | translate }}</span>
            <div class="candidate-segment" role="tablist" [attr.aria-label]="'CROP_IA_PREVIEW_CANDIDATE' | translate">
              <button
                type="button"
                class="segment-btn"
                role="tab"
                [attr.aria-selected]="selectedCandidateI() === 0"
                [class.segment-btn--active]="selectedCandidateI() === 0"
                (click)="selectCandidateIndex(0)">
                {{ 'CROP_IA_CANDIDATE_1' | translate }}
              </button>
              <button
                type="button"
                class="segment-btn"
                role="tab"
                [attr.aria-selected]="selectedCandidateI() === 1"
                [class.segment-btn--active]="selectedCandidateI() === 1"
                (click)="selectCandidateIndex(1)">
                {{ 'CROP_IA_CANDIDATE_2' | translate }}
              </button>
            </div>
          </div>
        }
        @let idx = selectedCandidateI();
        @if (topCandidates[idx]; as cand) {
          <div class="candidate-detail text-sm flex flex-column gap-1 surface-ground p-2 border-round">
            <div><strong>{{ 'Culture' | translate }}:</strong> {{ cand.names | localizeValuePipe }}</div>
            @if (cand.score != null) {
              <div>
                <strong>{{ 'PROBABILITY_PERCENT' | translate }}:</strong>
                {{ cand.score * 100 | number:'1.1-1' }}%
              </div>
            }
          </div>
        }
      </div>
    }
    @if (formData.polygonJson) {
      <div class="modal-map-host">
        <mfs-old-map
          [height]="'100%'"
          [zoom]="18"
          [drawingMode]="true"
          [polygonJson]="formData.polygonJson"
          [(geometry)]="config.data.model.polygon"
          [(polygonArea)]="formData.fieldArea"
          [isCenterMarker]="false"
          [polygonColor]="polygonFillHex()"
          [polygonStripeColor]="polygonStripeHex()"
          [(canSave)]="canSave"
        ></mfs-old-map>
      </div>
    } @else {
      <h3>{{ 'Field boundaries are missing' | translate }}</h3>
    }
  </div>
  <div class="form-section col-6 flex flex-column">
    @if (getFieldId()) {
      <div class="field-meta-row flex flex-row flex-wrap w-full align-items-center">
        <div class="field-meta-item">
          <span class="field-meta-label">{{ 'Field' | translate }}:</span>
          <app-field-passport-link
            [fieldId]="getFieldId()"
            [fieldName]="getFieldName()"
          />
        </div>
        <div class="field-meta-item field-meta-item--end">
          <span class="field-meta-label">{{ 'ACTUAL_CULTURE' | translate }}:</span>
          <span class="field-meta-text">{{ topCandidates[0]?.names | localizeValuePipe }}</span>
        </div>
      </div>
    }
    <msf-form-builder
      flexDirection="row"
      [fields]="config.data.fields"
      [(model)]="config.data.model"
    ></msf-form-builder>
    @if (getFieldId()) {
      <div class="form-section-footer">
        <app-primary-button
          title="Create request"
          (action)="openCreateRequest($event)"
        ></app-primary-button>
      </div>
    }
  </div>
</div>
